import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Política de Privacidad | CodeLiance';
  }, []);

  return (
    <div className="min-h-screen bg-[#050608]">
      <Navbar />
      
      <section className="pt-32 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-black text-white mb-8">
            Política de <span className="text-[#00C2FF]">Privacidad</span>
          </h1>
          
          <p className="text-gray-400 mb-8">
            Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Responsable del Tratamiento</h2>
              <p>
                <strong>CodeLiance</strong>, con sede en Colombia, es responsable del tratamiento de sus datos personales. 
                Puede contactarnos en:
              </p>
              <ul className="mt-4 space-y-2">
                <li>📧 Email: comercial@codeliance.co</li>
                <li>📱 Teléfono: +57 301 740 0570</li>
                <li>🌐 Web: https://codeliance.co</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Datos que Recopilamos</h2>
              <p>Recopilamos los siguientes datos a través de nuestro formulario de contacto:</p>
              <ul className="mt-4 list-disc list-inside space-y-2">
                <li>Nombre completo</li>
                <li>Correo electrónico corporativo</li>
                <li>Teléfono de contacto</li>
                <li>Nombre de la empresa</li>
                <li>Mensaje o consulta</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Finalidad del Tratamiento</h2>
              <p>Sus datos serán utilizados exclusivamente para:</p>
              <ul className="mt-4 list-disc list-inside space-y-2">
                <li>Responder a su consulta o solicitud de información</li>
                <li>Establecer comunicación comercial sobre nuestros servicios</li>
                <li>Enviar información sobre presupuestos y cotizaciones</li>
                <li>Mejorar nuestros servicios mediante análisis de datos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Base Legal del Tratamiento</h2>
              <p>
                El tratamiento de sus datos se fundamenta en su consentimiento expreso, 
                которое usted otorga al marcar la casilla aceptando esta política de privacidad 
                antes de enviar el formulario.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Derechos del Titular (Ley 1581 de 2012)</h2>
              <p>De acuerdo con la legislación colombiana, usted tiene derecho a:</p>
              <ul className="mt-4 list-disc list-inside space-y-2">
                <li><strong>Acceder:</strong> Conocer qué datos personales tenemos sobre usted</li>
                <li><strong>Rectificar:</strong> Solicitar corrección de datos erróneos o incompletos</li>
                <li><strong>Suprimir:</strong> Solicitar eliminación de sus datos cuando sea procedente</li>
                <li><strong>Revocar:</strong> Retirar el consentimiento dado anteriormente</li>
                <li><strong>Ser informado:</strong> Conocer el uso que se da a sus datos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Tiempo de Conservación</h2>
              <p>
                Sus datos serán conservados durante el tiempo necesario para cumplir con las 
                finalidades descritas, o hasta que usted solicite su eliminación. 
                Pasados 5 años de inactividad, procederemos a eliminar sus datos de nuestros sistemas.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Medidas de Seguridad</h2>
              <p>
                Implementamos medidas técnicas y organizativas apropiadas para proteger sus 
                datos personales contra pérdida, acceso no autorizado, modificación o divulgación. 
                Utilizamos protocolos de seguridad SSL/TLS para la transmisión de datos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Transferencia de Datos</h2>
              <p>
                CodeLiance no vende, alquila ni cede sus datos personales a terceros. 
                Sus datos solo serán compartidos con proveedores de servicios que actúan 
                como encargados del tratamiento bajo estrictos contratos de confidencialidad.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Reclamaciones</h2>
              <p>
                Si considera que sus derechos han sido vulnerados, puede presentar una 
                reclamación ante la <strong>Superintendencia de Industria y Comercio</strong> 
                (www.sic.gov.co).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Cambios a esta Política</h2>
              <p>
                Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento. 
                Cualquier cambio será publicado en esta página con la fecha de última actualización.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Aceptación</h2>
              <p>
                Al utilizar nuestro sitio web y/o proporcionar sus datos a través del 
                formulario de contacto, usted manifiesta haber leído y aceptado 
                expresamente esta política de tratamiento de datos personales.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
